import _home from "@/views/layouts/index.vue";
export default[
  {
    path: "/login",
    name: "login",
    meta: {
      title: "Login - 登录",
      hideInMenu: true,
      showHeaderNav: false
    },
    component: () => import("@/views/login/login.vue")
  },
  {
    path: "/",
    name: "index",
    redirect: "/index",
    component: _home,
    meta: {
      hideInMenu: true,
      notCache: true
    },
    children: [
      {
        path: "/index",
        name: "index",
        meta: {
          title: "首页",
          icon: "ios-home"
        },
        component: () => import("@/views/home.vue")
      }
      ]
  },
  {
    path: "/sports",
    name: "sports",
    meta: {
      title: "运动联盟",
      hideInMenu: true,
      showHeaderNav: false
    },
    component: () => import("@/views/sports/index.vue")
  },
  {
    path: "/join",
    name: "join",
    meta: {
      title: "我要加入",
      hideInMenu: true,
      showHeaderNav: false
    },
    component: () => import("@/views/join/index.vue")
  },
  {
    path: "/draw",
    name: "draw",
    meta: {
      title: "奖励措施",
      hideInMenu: true,
      showHeaderNav: false
    },
    component: () => import("@/views/sports/rule.vue")
  },
  {
    path: "/group",
    name: "group",
    meta: {
      title: "联盟列表",
      hideInMenu: true,
      showHeaderNav: false
    },
    component: () => import("@/views/group/index.vue")
  },
  {
    path: "/point",
    name: "point",
    meta: {
      title: "积分",
      hideInMenu: true,
      showHeaderNav: false,
      bgcolor: "#E6F2FE"
    },
    component: () => import("@/views/group/point.vue")
  },
  {
    path: "/groupdetail/:aid",
    name: "groupdetail",
    meta: {
      title: "联盟详情",
      hideInMenu: true,
      showHeaderNav: false,
      bgcolor: ""
    },
    component: () => import("@/views/group/detail.vue")
  },
  {
    path: "/match",
    name: "match",
    meta: {
      title: "赛事活动情况季度汇总表",
      hideInMenu: true,
      showHeaderNav: false,
      bgcolor: "#E6F2FE"
    },
    component: () => import("@/views/match/index.vue")
  },
  {
    path: "/topic",
    name: "topic",
    meta: {
      title: "讲座培训情况季度汇总表",
      hideInMenu: true,
      showHeaderNav: false,
      bgcolor: "#E6F2FE"
    },
    component: () => import("@/views/topic/index.vue")
  },
];
